// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/efb-critical-phase-display.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/efb-critical-phase-display/efb-critical-phase-display.js';
import g1 from '../lessons/navigation/efb-critical-phase-display/efb-display-crosscheck.js';
import g2 from '../lessons/navigation/efb-critical-phase-display/efb-primary-field-of-view.js';
import g3 from '../lessons/navigation/efb-critical-phase-display/efb-report-errors.js';
import g4 from '../lessons/navigation/efb-critical-phase-display/efb-viewing-position.js';
import g5 from '../lessons/navigation/efb-critical-phase-display/efb-workload-procedures.js';

mount([g0, g1, g2, g3, g4, g5]);
